import { Button } from '@mui/material'
import type React from 'react'
import { type ReactNode, useState } from 'react'
import { useAuth } from '../hooks/useAuth'
import { ModalDelDialog } from './ModalDelDialog'

type UserDelButtonProps = {
  children: ReactNode
  title: string
  loginId?: string
  isDisabled: boolean
  onDel: (text: string) => void
}

export const UserDelButton: React.FC<UserDelButtonProps> = props => {
  const [open, setOpen] = useState(false)
  const auth = useAuth()
  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const onClickHandler = async () => {
    handleOpen()
  }

  return (
    <>
      {open && (
        <ModalDelDialog
          open={open}
          title={props.title}
          id={props.loginId}
          onClose={handleClose}
          onDel={props.onDel}
        />
      )}
      <Button
        disabled={props.isDisabled || auth.isDisable}
        onClick={onClickHandler}
        sx={{
          // justifyContent: "flex-start",
          alignContent: 'center',
          color: props.isDisabled ? '#CACACA' : '#FFFFFF',
          font: 'normal normal bold 21px/32px Noto Sans JP',
          // paddingLeft: "32px",
          textAlign: 'left',
          backgroundColor: props.isDisabled ? '#F4F4F4' : '#FF0000',
          '&:hover': {
            backgroundColor: props.isDisabled ? '#F4F4F4' : '#FF0000',
            opacity: 0.7,
          },
          boxShadow: '0px 2px 2px #00000014',
          height: '54px',
          width: '189px',
          borderRadius: '40px',
        }}
      >
        {props.children}
      </Button>
    </>
  )
}
